<template>
  <div>
    <title-bar :title-stack="titleStack" />
    <hero-bar>
      Rules List
      <div slot="right">
        <b-button
          v-if="isEditAllowed"
          type="is-primary import-button"
          @click="clickAddRule"
          >+ &nbsp;Add Rule</b-button
        >
      </div>
    </hero-bar>
    <section class="section is-main-section">
      <circul8-table
        :records="data"
        :fields="columns"
        :usePropRecords="true"
        :listingComponent="true"
        :isCheckable="true"
        :maxTextLength="'48'"
        :isLoading="isDataLoading"
        :showEditButton="true"
        :backendSortingEnabled="true"
        :routeNext="false"
        :showRemoveButton="isEditAllowed"
        @clickEdit="clickEditRule"
        @clickView="viewRule"
        @clickDelete="deleteModal"
        @backendSort="sortData"
        @querySet="searchByFilter"
        @loadNextPage="pullNextPage"
        :enableInfiniteScroll="true"
        :hasNextData="nextData"
        :hasPreviousData="previousData"
        @loadPreviousPage="pullPreviousPage"
      />
      <div class="records-displayed" v-if="totalRecords > 0">
        <span v-if="currentPage * 50 + 50 < totalRecords"
          >displaying {{ currentPage > 1 ? currentPage * 50 - 50 : 0 }} -
          {{
            currentPage > 0
              ? nextPageCursor
                ? currentPage * 50 - 50 + data.length
                : totalRecords
              : data.length
          }}
          records out of {{ totalRecords }} records</span
        >
        <div v-else>
          <span v-if="currentPage == 0">
            displaying 0 - {{ totalRecords }} records out of
            {{ totalRecords }} records
          </span>
          <span v-else>
            displaying {{ currentPage * 50 - 50 }} - {{ totalRecords }} records
            out of {{ totalRecords }} records
          </span>
        </div>
      </div>
    </section>
    <add-rules
      :is-active="isModalActive"
      :view-only="viewOnly"
      :action="action"
      :form="editObjectName"
      @addNew="addRule"
      @cancel="editCancel"
      :rules="data"
      @copyRule="copyCreatedRule"
    />
    <create-rules
      :is-active="isCreateRulesModalActive"
      :view-only="viewOnly"
      :action="action"
      :form="editObjectName"
      @confirm="createRule"
      @cancel="cancelCreateRule"
      :rules="formData"
      @viewSyntex="openViewSyntex"
      @checkReportDef="openReportDefList"
      :rule-tags="ruleTags"
    />
    <view-rules
      :is-active="isViewModalActive"
      :formData="editObjectName"
      @confirm="clickEditRule"
      @cancel="cancelViewRule"
      :show-edit-button="isEditAllowed"
      @checkReportDef="openReportDefList"
      :rule-tags="ruleTags"
    />
    <view-syntex
      :is-active="isViewSyntexModalActive"
      :formData="editObjectName"
      @cancel="cancelViewSyntex"
    />
    <view-report-def
      :is-active="isViewReportDefModalActive"
      :formData="editObjectName"
      @cancel="cancelViewReportDef"
    />
  </div>
</template>

<script>
import TitleBar from "@/components/TitleBar";
import HeroBar from "@/components/HeroBar";
import Circul8Table from "../../components/Circul8Table.vue";
import RulesManagerService from "../../services/RulesManagerService";
import AddRules from "@/components/RulesManager/AddRules.vue";
import CreateRules from "@/components/RulesManager/CreateRules.vue";
import ViewRules from "@/components/RulesManager/ViewRules.vue";
import { mapGetters } from "vuex";
import UtilityMixin from "@/mixins/UtilityMixin";
import ScopeMixin from "@/mixins/scopeMixin";
import ViewSyntex from "@/components/RulesManager/ViewSyntex.vue";
import ViewReportDef from "@/components/RulesManager/ViewReportDef.vue";
import { UserGroup } from "@/services/UserGroups";
import * as dayjs from "dayjs";

export default {
  name: "RulesList",
  mixins: [UtilityMixin, ScopeMixin],
  components: {
    HeroBar,
    TitleBar,
    Circul8Table,
    CreateRules,
    AddRules,
    ViewRules,
    ViewSyntex,
    ViewReportDef
  },
  data() {
    return {
      isViewSyntexModalActive: false,
      isViewReportDefModalActive: false,
      isViewModalActive: false,
      isCopy: false,
      data: [],
      formData: {},
      isDataLoading: false,
      isModalActive: false,
      isCreateRulesModalActive: false,
      action: null,
      isAdd: false,
      editObject: this.getClearFormObject(),
      viewOnly: false,
      nextPageCursor: "",
      PreviousPageCursor: "",
      loadMoreClicked: false,
      lastSortColumn: null,
      lastSortOrder: null,
      enableLoadMore: false,
      totalRecords: 0,
      isLoading: false,
      nextData: false,
      previousData: false,
      currentPage: 0,
      tree: {},
      query: "",
      ruleTags: [],
      columns: [
        {
          field: "name",
          label: "Rule Name",
          searchable: true,
          filterKey: { name: "" },
          type: "input"
        },
        {
          field: "updated_by_name",
          label: "Last Updated By",
          searchable: true,
          filterKey: { updated_by_name: "" },
          type: "input"
        },
        {
          field: "updated_at",
          label: "Last Updated",
          searchable: true,
          filterKey: { updated_at: "" },
          type: "dateField"
        },
        {
          field: "condition_sql",
          label: "sql",
          searchable: true,
          filterKey: { condition_sql: "" },
          type: "input"
        },
        {
          field: "tags",
          label: "Tags",
          width: "200",
          searchable: true,
          visible: true,
          searchKey: "tags",
          type: "multiSelectFilter",
          multiSelectFilter: true,
          initStatusVals: [],
          allStatusVals: [
            {
              name: "WEEE"
            },
            {
              name: "BATT"
            },
            {
              name: "PACK and PACK Sub Streams"
            },
            {
              name: "CDF TD"
            }
          ],
          filterKey: {
            tags: [],
            field_name: "name"
          }
        },
        {
          field: "actions",
          label: "",
          headerClass: "is-actions",
          cellClass: "is-actions",
          visible: true,
          searchable: true,
          type: "actionSearch",
          actionSearch: true,
          filterKey: { actions: "" }
        }
      ],
      RulesManagerService: new RulesManagerService()
    };
  },
  mounted() {
    this.fetchRuleTags();
    this.checkExternalPermission();
    this.fetchPropertyData();
    this.fetchOperatorData();
  },
  computed: {
    ...mapGetters(["userId", "userName", "userHasPermission", "userGroups"]),
    editObjectName() {
      return this.editObject || this.getClearFormObject();
    },
    titleStack() {
      return [
        { url: "#", name: "Rule Manager" },
        { url: "/ruleManager/scope", name: "Scopes" }
      ];
    },
    isEditAllowed() {
      if (this.userGroups.includes(UserGroup.EPR_ADMIN)) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    fetchRuleTags() {
      this.RulesManagerService.getRulesTags().subscribe(response => {
        this.ruleTags = response;
        this.fetchRuleList();
      });
    },
    fetchPropertyData() {
      this.isDataLoading = true;
      this.RulesManagerService.getPropertyConfig().subscribe(response => {
        this.$store.state.properties = response;
      });
    },
    fetchOperatorData() {
      this.isDataLoading = true;
      this.RulesManagerService.getOperatorConfig().subscribe(response => {
        this.$store.state.operators = response;
      });
    },
    copyCreatedRule(ruleId) {
      this.isCreateRulesModalActive = true;
      this.isModalActive = false;
      this.getRuleById(ruleId);
      this.isCopy = true;
    },

    getRuleById(ruleId) {
      this.RulesManagerService.getRuleById(ruleId).subscribe(response => {
        this.formData = response;
        this.editObject.report_definition = response.report_definition;
        // Replace property definitions with the ones from config
        this.updateRuleWithConfigProperties(response);
        if (this.isCopy) {
          this.formData.name = this.formData.name + " - Copy";
        }
      });
    },
    ensurePropertyConfigLoaded() {
      return new Promise(resolve => {
        if (
          this.$store.state.properties &&
          this.$store.state.properties.length > 0
        ) {
          resolve();
        } else {
          this.RulesManagerService.getPropertyConfig().subscribe(response => {
            this.$store.state.properties = response;
            resolve();
          });
        }
      });
    },
    // Process each node to use config properties
    processNodeWithConfigProperties(node) {
      if (node.children) {
        node.children.forEach(child => {
          // Update the property in each node
          if (child.form && child.form.property) {
            const selectedValue = child.form.value;
            const selectedPropertyId = child.form.property.id;

            // Find matching property in config
            const configProperty = this.$store.state.properties.find(
              p => p.id === selectedPropertyId
            );

            if (configProperty) {
              // Replace property but keep the selected value
              child.form.property = configProperty;
              child.form.value = selectedValue;
            }
          }

          // Process nested children
          if (child.children) {
            this.processNodeWithConfigProperties(child);
          }
        });
      }
    },
    // Update rule with property definitions from config
    updateRuleWithConfigProperties(rule) {
      if (rule.rule_json && rule.rule_json.children) {
        this.processNodeWithConfigProperties(rule.rule_json);
      }
    },
    cancelCreateRule() {
      this.isCreateRulesModalActive = false;
    },
    cancelViewRule() {
      this.isViewModalActive = false;
    },
    createRule(formData) {
      this.data = [];
      if (this.action == "Edit") {
        this.RulesManagerService.editRule(
          this.editObject.id,
          formData
        ).subscribe(() => {
          this.$buefy.toast.open({
            message: "Data is edited successfully!",
            type: "is-success"
          });
          this.isCreateRulesModalActive = false;
          this.fetchRuleList();
        }, this.handleApiError);
      } else {
        this.RulesManagerService.createRule(formData).subscribe(response => {
          if (response.message) {
            let rulesName = "";
            response.rules.forEach(item => {
              rulesName = rulesName + item.name + "</br>";
            }),
              this.$buefy.dialog.confirm({
                title: "Warning",
                message:
                  "<b>" +
                  response.message +
                  ", Name of the similar rule is : </b></br>" +
                  rulesName,
                type: "is-primary",
                cancelText: "Close",
                confirmText: "Create Rule",
                onConfirm: () => this.forceCreateRule(formData)
              });
            //this.fetchRuleList();
          } else {
            this.$buefy.toast.open({
              message: "Data is added successfully!",
              type: "is-success"
            });
            this.isCreateRulesModalActive = false;
            this.fetchRuleList();
          }
        }, this.handleApiError);
      }
    },
    forceCreateRule(formData) {
      this.RulesManagerService.createRule(formData, 1).subscribe(() => {
        this.$buefy.toast.open({
          message: "Data is added successfully!",
          type: "is-success"
        });
        this.isCreateRulesModalActive = false;
        this.data = [];
        this.fetchRuleList();
      }, this.handleApiError);
    },
    getClearFormObject() {
      return {
        id: null,
        country: null,
        scheme: null,
        stream: null
      };
    },
    cancelViewSyntex() {
      this.isViewSyntexModalActive = false;
    },
    openViewSyntex() {
      this.isViewSyntexModalActive = true;
    },
    openReportDefList() {
      this.isViewReportDefModalActive = true;
    },
    cancelViewReportDef() {
      this.isViewReportDefModalActive = false;
    },
    clickAddRule() {
      this.viewOnly = false;
      this.action = "Add";
      this.isAdd = true;
      this.editObject = this.getClearFormObject();
      this.isModalActive = true;
    },
    editFromView(editObject) {
      this.isViewModalActive = false;
      this.action = "Edit";
      this.isAdd = true;
      this.editObject = editObject;
      this.isCreateRulesModalActive = true;
    },
    clickEditRule(editObject) {
      this.isCopy = false;
      this.isViewModalActive = false;
      this.viewOnly = false;
      this.action = "Edit";
      this.isAdd = true;
      this.editObject = editObject;
      this.isCreateRulesModalActive = true;
      this.getRuleById(editObject.id);
    },
    viewRule(editObject) {
      this.editObject = editObject;
      this.isViewModalActive = true;
      this.editObject = editObject;
      this.getRuleById(editObject.id);
    },

    addRule() {
      this.isCreateRulesModalActive = true;
    },

    editCancel() {
      this.isModalActive = false;
    },
    prepareData(data) {
      const dataList = [];
      for (const report in data) {
        const reportData = data[report];
        reportData["updated_at"] = dayjs(reportData["updated_at"]).format(
          "YYYY-MM-DD, HH:mm"
        );
        const tagSelected = this.ruleTags
          .filter(item => reportData["tags"].includes(item.id))
          .map(a => a.name)
          .toString();

        reportData["tags"] = tagSelected == "" ? "NA" : tagSelected;
        reportData["actions"] = this.isEditAllowed;
        reportData["delete"] = this.isEditAllowed;
        dataList.push(reportData);
      }

      if (this.nextPageCursor == null) {
        this.data.push(...dataList);
        if (this.currentPage > 1) {
          this.currentPage = this.currentPage - 1;
          if (this.currentPage == 1) {
            this.previousData = false;
          }
        } else {
          this.currentPage = this.currentPage - 1;
          this.previousData = false;
        }
      } else {
        this.data = dataList;
      }
      this.isDataLoading = false;
    },
    pullNextPage() {
      this.previousData = true;
      this.loadMoreClicked = true;
      this.currentPage = this.currentPage + 1;
      const temp = this.nextPageCursor.split("?")[1].split("&");
      const query_part = temp.filter(function(value) {
        return value.indexOf("page=") == -1;
      });
      if (this.nextPageCursor != null || this.nextPageCursor != undefined) {
        this.query =
          "&" + query_part.join("&") + "&page=" + (this.currentPage + 1) + "&";
        this.fetchRuleList(this.query, "next");
      }
    },
    pullPreviousPage() {
      this.nextData = true;
      this.loadMoreClicked = true;
      const temp = this.PreviousPageCursor.split("?")[1].split("&");
      let query_part = temp.filter(function(value) {
        return value.indexOf("page=") == -1;
      });
      query_part = [...new Set(query_part)];
      if (this.currentPage == 0 || this.currentPage == 1) {
        this.query = "&" + query_part.join("&") + "&page=1&";
        this.previousData = false;
      } else {
        this.query =
          "&" + query_part.join("&") + "&page=" + this.currentPage + "&";
      }
      this.currentPage =
        this.currentPage > 0 ? this.currentPage - 1 : this.currentPage;
      this.fetchRuleList(this.query, "prev");
    },
    searchByFilter(filterQuery) {
      this.nextPageCursor = null;
      this.currentPage = 0;
      this.data = [];
      this.nextData = false;
      this.query = "&" + filterQuery;
      //      this.displayedRecords = 0;

      let query = "";
      if (this.lastSortColumn) {
        query += "&order_field" + "=" + this.lastSortColumn;
        query += "&order_by" + "=" + this.lastSortOrder;
        query += this.query;
      } else {
        query = this.query;
      }
      this.fetchRuleList(query);
    },
    sortData(field, order) {
      this.loadMoreClicked = false;
      this.nextPageCursor = null;
      this.currentPage = 0;
      this.data = [];
      this.nextData = false;
      // sort should always fetch page 1, so removing page param if exist
      this.query = this.query.replace(/page=[0-9.]{1,2}&/g, "");
      const oldOrderField = "&order_field" + "=" + this.lastSortColumn;
      const oldOrderValue = "&order_by" + "=" + this.lastSortOrder;
      const newOrderField = "&order_field" + "=" + field;
      const newOrderValue = "&order_by" + "=" + order;

      this.query = this.replaceOrAddParanInSearchQuery(
        oldOrderField,
        newOrderField
      );
      this.query = this.replaceOrAddParanInSearchQuery(
        oldOrderValue,
        newOrderValue
      );

      //     this.displayedRecords = 0;
      this.lastSortColumn = field;
      this.lastSortOrder = order;
      this.fetchRuleList(this.query);
    },

    replaceOrAddParanInSearchQuery(oldParam, newParam) {
      if (this.query.includes(oldParam)) {
        this.query = this.query.replace(oldParam, newParam);
      } else {
        this.query += newParam;
      }
      return this.query;
    },
    fetchRuleList(query = "", scrollDir) {
      this.isLoading = true;
      //this.data = [];
      this.RulesManagerService.getRulesData(query).subscribe(
        response => {
          this.PreviousPageCursor = this.nextPageCursor
            ? this.nextPageCursor
            : this.PreviousPageCursor;
          this.nextPageCursor = response["next"];
          if (this.currentPage > 1) {
            this.previousData = true;
            if (this.nextPageCursor != null) {
              this.enableLoadMore = this.nextData = true;
            } else {
              this.enableLoadMore = this.nextData = false;
            }
          } else {
            this.enableLoadMore = this.previousData = false;
            if (this.nextPageCursor != null) {
              this.enableLoadMore = this.nextData = true;
            } else {
              this.enableLoadMore = this.nextData = false;
            }
          }
          this.totalRecords = response["count"];
          let tempData = [];
          if (scrollDir == "next") {
            //this.totalRecords = this.data.length + response["count"];
            if (!this.nextPageCursor) {
              this.prepareData(response["results"]);
            } else {
              tempData = [...this.data, ...response["results"]];
              if (tempData.length > 100 && this.nextPageCursor != null) {
                tempData = tempData.slice(50, 150);
              }
              this.prepareData(tempData);
            }
          } else if (scrollDir == "prev") {
            if (this.currentPage == 0) {
              this.prepareData(response["results"]);
            } else {
              tempData = [...response["results"], ...this.data];
              if (tempData.length >= 100) {
                tempData = tempData.slice(0, 100);
              }
              this.prepareData(tempData);
            }
          } else {
            this.prepareData(response["results"]);
          }
          this.isLoading = false;
        },
        e => {
          console.log(e);
          this.isLoading = false;
          this.isDataLoading = false;
          this.nextData = false;
        }
      );
    },
    handleApiError(reason) {
      let errorMessage = null;
      if (reason?.response?.data) {
        if (reason.response.data["detail"]) {
          errorMessage = reason.response.data["detail"];
        } else if (reason.response.data["error"]) {
          errorMessage = reason.response.data["error"];
        } else if (reason.response.data["name"]) {
          errorMessage = reason.response.data["name"];
        } else {
          errorMessage = "Invalid input";
        }
      }
      this.$buefy.dialog.alert({
        title: "Error",
        message: errorMessage,
        type: "is-danger",
        ariaRole: "alertdialog",
        ariaModal: true
      });
      this.fetchRuleList();
      this.isDataLoading = false;
      this.isLoading = false;
    },

    updateReportDefinition(params) {
      try {
        this.RulesManagerService.updateReportDefinition(params).subscribe(
          () => {
            this.$buefy.toast.open("Rule deleted!");
            this.data = [];
            this.fetchRuleList();
          },
          e => {
            this.handleApiError(e);
            this.isDataLoading = false;
          }
        );
      } catch (e) {
        this.handleApiError(e);
        this.isDataLoading = false;
      }
    },

    deleteModal(editObject) {
      this.$buefy.dialog.confirm({
        title: "Deleting Rule",
        message: "Are you sure you want to <b>delete</b> this rule?",
        confirmText: "Delete rule",
        hasIcon: true,
        onConfirm: () => this.deleteRule(editObject)
      });
    },
    deleteRule(editObject) {
      try {
        this.RulesManagerService.deleteRule(editObject).subscribe(
          response => {
            let reports = "";
            let msg = "";
            if (response.message) {
              if (
                response.report_definitions &&
                response.report_definitions.length > 0
              ) {
                msg = msg + "<br>This is part of the following ";

                msg =
                  response.report_definitions.length > 1
                    ? msg + "Report Definitions: "
                    : msg + "Report Definition: ";
                response.report_definitions.forEach((item, index) => {
                  reports = reports + "records=" + item.id + "&";
                  msg =
                    msg +
                    "<br><b>" +
                    (index + 1) +
                    ". " +
                    item.report +
                    " (" +
                    item.valid_from +
                    " - " +
                    item.valid_to +
                    ") " +
                    item.status +
                    "</b> ";
                });
              }
              if (response.scope && response.scope.length > 0) {
                msg =
                  response.report_definitions.length > 1
                    ? msg + "<br>And this "
                    : msg + "<br>This ";
                msg = msg + "is part of the following ";

                msg =
                  response.scope.length > 1
                    ? msg + "Scopes: "
                    : msg + "Scope: ";
                response.scope.forEach((item, index) => {
                  reports = reports + "scope_records=" + item.id + "&";
                  msg =
                    msg +
                    "<br><b>" +
                    (index + 1) +
                    ". " +
                    item.country +
                    " - " +
                    item.scheme +
                    " - " +
                    item.stream;
                  const msg2 = item.valid_from
                    ? " (" + item.valid_to + " - " + item.valid_from + " )"
                    : " ( NA ) ";
                  msg = msg + msg2 + item.status + "</b> ";
                });
              }
              msg =
                msg +
                "<br> Are you sure you want to go ahead? If yes, all affected Report Definitions/Scopes will go back to status “draft” ";
              reports = reports + "record_type=rule&record_id=" + editObject.id;
              this.$buefy.dialog.confirm({
                title: "Warning!",
                message: msg,
                type: "is-danger",
                ariaRole: "alertdialog",
                ariaModal: true,
                confirmText: "Yes",
                onConfirm: () => this.updateReportDefinition(reports)
              });
            } else {
              this.$buefy.toast.open("Rule deleted!");
              this.data = [];
              this.fetchRuleList(this.query);
            }
          },
          e => {
            this.handleApiError(e);
            this.isDataLoading = false;
          }
        );
      } catch (e) {
        this.handleApiError(e);
        this.isDataLoading = false;
      }
    }
  }
};
</script>
